/**
 * 登录首页
 */

export default {
  // 登录后在首页是否弹框显示未审核的运单
  uncheck_order_tips_in_home: ['88114'] // 202506091721193307057
}
